import { validateResolveRound as coreValidateResolveRound } from "@cloudnest/stone-flicking-core-engine/validators";
import type { ResolveRoundAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingState } from "../types/game-state";

export function validateResolveRound(
  state: StoneFlickingState,
  action: ResolveRoundAction,
): ValidationResult {
  return coreValidateResolveRound(state.coreState, action);
}
